import {createContext} from 'react';

const clienteContext = createContext();

export default clienteContext;